import React, { useMemo } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'

import DraftHTML from '../widgets/DraftHTML'
import ImageGallery from '../widgets/ImageGallery'
import useReplaceLinkTarget from '../hooks/useReplaceLinkTarget'

import {
  getUrl,
} from 'utils/storage'

const useStyles = makeStyles(theme => ({
  root: {
    
  },
  button: {
    textAlign: 'left',
  },
  gallery: {
    border: '1px solid #ccc',
    // marginLeft: theme.spacing(6),
    // marginRight: theme.spacing(6),
  },
  datesTitle: {
    marginBottom: theme.spacing(2),
  },
  singleImage: {
    width: '100%',
  }
}))

const BookingFormWelcomeEmbedHTML = ({
  html,
}) => {

  const classes = useStyles()
  const rootRef = useReplaceLinkTarget({
    target: '_self',
    html,
  })

  return (
    <div ref={ rootRef }>
      <Typography variant="h6" gutterBottom color="primary" className={ classes.datesTitle }>
        Upcoming Dates
      </Typography>
      <div dangerouslySetInnerHTML={{__html: html}}>

      </div>
    </div>
  )
}

const BookingFormWelcome = ({
  data,
  embedHTML,
  onProceed,
}) => {
  const classes = useStyles()
  const theme = useTheme()
  const isLarge = useMediaQuery(theme.breakpoints.up('sm'))
  
  const images = useMemo(() => {
    const list = data && data.meta && data.meta.homepage_images || []
    return list.map(item => getUrl(item.file.filepath))
  }, [
    data,
  ])

  if(!data || !data.meta) return null

  return (
    <div className={ classes.root }>
      <Grid container spacing={ 2 } alignItems="flex-start">
        <Grid item xs={ 12 }>
        {
          data.meta.homepage_title && (
            <Typography variant="h6" gutterBottom color="primary">
              { data.meta.homepage_title }
            </Typography>
          )
        }
        </Grid>
        <Grid item xs={ 12 }>
          <div className={ classes.button }>
            <Button
              size="large"
              variant="contained"
              color="primary"
              onClick={ onProceed }
            >
              Start Booking
            </Button>
          </div>
        </Grid>
        <Grid item xs={ 12 }>
        {
          data.meta.homepage_intro && (
            <DraftHTML
              linkTarget="_blank"
              html={ data.meta.homepage_intro_html }
            />
          )
        }
        </Grid>
        <Grid item xs={ 12 } sm={ 6 }>
          {
            images.length > 0 && (
              <div className={ classes.gallery }>
                {
                  isLarge ? (
                    <ImageGallery
                      images={ images }
                    />
                  ) : (
                    <img className={ classes.singleImage } src={ images[0] } />
                  )
                }
                
              </div>
              
            )
          }
        </Grid>
        <Grid item xs={ 12 } sm={ 6 }>
          {
            embedHTML && (
              <BookingFormWelcomeEmbedHTML
                html={ embedHTML }
              /> 
            )
          }
        </Grid>
        <Grid item xs={ 12 }>
        {
          data.meta.homepage_footer && (
            <DraftHTML
              linkTarget="_blank"
              html={ data.meta.homepage_footer_html }
            />
          )
        }
        </Grid>
        <Grid item xs={ 12 }>
          <div className={ classes.button }>
            <Button
              size="large"
              variant="contained"
              color="primary"
              onClick={ onProceed }
            >
              Start Booking
            </Button>
          </div>
        </Grid>
      </Grid>
  
      
    </div>
  )
}

export default BookingFormWelcome